import script from "./FooterInPC.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterInPC.vue?vue&type=script&setup=true&lang=js"

import "./FooterInPC.vue?vue&type=style&index=0&id=3aa6ce72&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa6ce72"]])

export default __exports__